import { reportGasMovementsTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_GAS_MOVEMENTS_FILTERS, RESTORE_INITIAL } = reportGasMovementsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportGasMovementsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_GAS_MOVEMENTS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState
    default:
      return state;
  }
};